module.exports = __webpack_public_path__ + "fonts/soehne-buch.f4f4bf3.woff2";